import { DatePicker as AntdDatePicker } from 'antd';

import styled from 'styled-components';

import { BODY_2_REG_2 } from 'src/client/constants/text';

const { RangePicker: AntdRangePicker } = AntdDatePicker;

export const StyledDatePicker = styled(AntdDatePicker)`
  padding: 0 8px;
  height: ${(props) => props.theme.input.middle.height};
  width: 100%;
  border-radius: ${(props) => props.theme.input.middle.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.darkEmphasis3};

  && input {
    ${BODY_2_REG_2};
    line-height: 100%;
  }

  :hover {
    border: 1px solid black;
  }

  &.ant-picker-focused {
    box-shadow: none;
    border: 1px solid black;
  }

  &.ant-picker-large {
    padding: 0 12px;
    height: ${(props) => props.theme.input.large.height};
    border-radius: ${(props) => props.theme.input.large.borderRadius};
  }
`;

export const StyledRangePicker = styled(AntdRangePicker)`
  padding: 0 8px;
  height: ${(props) => props.theme.input.middle.height};
  border-radius: ${(props) => props.theme.input.middle.borderRadius};

  &:hover,
  &.ant-picker-focused {
    border: 1px solid black;
    box-shadow: none;
  }

  && input {
    ${BODY_2_REG_2};
    line-height: 100%;
  }

  &.ant-picker-large {
    padding: 0 12px;
    height: ${(props) => props.theme.input.large.height};
    border-radius: ${(props) => props.theme.input.large.borderRadius};
  }
`;
